'use strict';

import { PRODUCT_FAMILIES, THERAPEUTIC_AREAS, STUDY_GOALS, STUDY_SIZES } from './studyBuilder.config.js';
import { summarizeServiceSelection } from './studyBuilder.serviceDisplay.js';

export function label(list, id) {
	return list.find((x) => x.id === id)?.label ?? id ?? '—';
}

export function therapeuticSummary(fit) {
	const ids = Array.isArray(fit.therapeuticAreas) ? fit.therapeuticAreas : [];
	if (ids.length === 0) return '—';
	const parts = ids.map((id) =>
		id === 'other-therapeutic' && fit.therapeuticAreaOther
			? `Other (${fit.therapeuticAreaOther})`
			: label(THERAPEUTIC_AREAS, id)
	);
	return parts.join(', ');
}

/** @param {Record<string, unknown>} fitSelections */
export function studyGoalLabel(fitSelections) {
	return fitSelections.studyGoal === 'other' && fitSelections.studyGoalOther
		? `Other (${fitSelections.studyGoalOther})`
		: label(STUDY_GOALS, fitSelections.studyGoal);
}

function scopeModeLabelText(mode) {
	if (mode === 'multiple') return 'Multiple matrices';
	if (mode === 'unsure') return 'Unsure';
	return 'Single matrix';
}

/**
 * @param {Record<string, unknown>} fitSelections
 * @param {{ name?: string }|null} primaryProduct
 */
export function selectionsSummaryLines(fitSelections, primaryProduct) {
	const line0 = (fitSelections.sampleLines || [])[0];
	const scopeMode = fitSelections.matrixScopeMode || 'single';
	const rows = [
		['Project name', fitSelections.projectName || '—'],
		['Product line', label(PRODUCT_FAMILIES, fitSelections.productFamily)],
		['Services', summarizeServiceSelection(fitSelections)],
		['Therapeutic areas', therapeuticSummary(fitSelections)],
		['Study goal', studyGoalLabel(fitSelections)],
		['Scope', scopeModeLabelText(scopeMode)],
	];

	if (scopeMode === 'single') {
		rows.push(['Species', line0?.species || '—']);
		rows.push(['Organism', line0?.matrix || '—']);
		rows.push(['Matrix', line0?.matrixCategory || '—']);
		rows.push(['Matrix Type', line0?.matrixType || '—']);
		rows.push(['Number of samples', line0?.count || '—']);
	} else {
		rows.push(['Number of matrices', fitSelections.numberOfMatrices || '—']);
		rows.push(['Approx. samples', line0?.count || '—']);
		const notes = String(line0?.otherNotes || '').trim();
		rows.push(['Notes', notes ? (notes.length > 80 ? notes.slice(0, 80) + '…' : notes) : '—']);
	}

	rows.push(['Quoted product (est.)', primaryProduct?.name ?? '—']);
	return rows;
}
